import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";
import { Box } from "@mui/material";
import { AiFillThunderbolt } from "react-icons/ai";
import { BsArrowsFullscreen } from "react-icons/bs";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PowerBiDashboard = ({ btnName }) => {
  const [open, setOpen] = React.useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  console.log("base url",baseUrl);
  
  const title = baseUrl?.split("//")[1]?.split(".")[0].toUpperCase();
  const src = process.env.REACT_APP_POWER_BI_REPORT_URL;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <button onClick={handleClickOpen} className="animated-btn ">
        {btnName ? (
          <>
            <span className="icon text-white pe-1">
              <BsArrowsFullscreen />
            </span>
            <span className="text-capitalize">{btnName}</span>{" "}
          </>
        ) : (
          <>
            <span className="icon text-secondary">
              <AiFillThunderbolt />
            </span>
            <span>AI Dashboard</span>
          </>
        )}
      </button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar
          sx={{ position: "relative", height: "40px" }}
          className="bg-primary "
        >
          <Toolbar className="pb-4">
            <Typography
              sx={{ ml: 2, flex: 1, fontSize: "16px" }}
              variant="h5"
              component="div"
              className="fw-semibold"
            >
              AI Dashboard
            </Typography>

            <IconButton
              edge="end"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Box>
        {baseUrl && src ?   <iframe
            title={`${title} E-Dashboard | Power BI`}
            className="w-100 border-0"
            style={{ height: "92vh" }}
            src={src}
            frameborder="0"
            allowFullScreen="true"
          ></iframe> : <div className="mt-5 d-flex justify-content-center fs-2 ">
          <div className="mx-auto">No Power-Bi Dashboard Allocated </div>
          </div>}
        </Box>
      </Dialog>
    </React.Fragment>
  );
};

export default PowerBiDashboard;
